import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { apiEventAll } from '@common/helper';
import { GetApproversStoreService } from '@common/services/api-store/sdk-reservation/get-approvers-store/get-approvers-store.service';
import { SupportModalBlockComponent } from '@lib/components/support-class';
import { isSP, isTB, isPC } from '@lib/helpers';
import { CommonLibService } from '@lib/services';
import { fromEvent, throttleTime } from 'rxjs';
import { OrdersAnaBizGetApproversResponseDataApproversInner } from 'src/sdk-reservation/model/ordersAnaBizGetApproversResponseDataApproversInner';

@Component({
  selector: 'asw-anabiz-payment-input-approver-list',
  templateUrl: './anabiz-payment-input-approver-list.component.html',
  styleUrls: ['./anabiz-payment-input-approver-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnabizPaymentInputApproverListComponent extends SupportModalBlockComponent {
  public approverList: Array<OrdersAnaBizGetApproversResponseDataApproversInner> = [];
  public searchText: string = '';
  public hasData: boolean = false;
  reload(): void {}

  get filteredItems(): Array<OrdersAnaBizGetApproversResponseDataApproversInner> {
    const res = this.approverList.filter((item) =>
      item.name?.toLocaleLowerCase().includes(this.searchText.toLocaleLowerCase())
    );
    if (res.length > 0) {
      this.hasData = true;
    } else {
      this.hasData = false;
    }
    return res;
  }

  //画面のサイズを切り替えの設定
  public isSp = isSP();
  public isTb = isTB();
  public isPc = isPC();
  private _isSpPre = isSP();
  private _isTbPre = isTB();
  private _isPcPre = isPC();

  /**
   * 画面のサイズを切り替えの設定
   */
  private _resizeEvent = () => {
    this._isSpPre = this.isSp;
    this._isTbPre = this.isTb;
    this._isPcPre = this.isPc;
    this.isSp = isSP();
    this.isTb = isTB();
    this.isPc = isPC();
    if (this._isSpPre !== this.isSp || this._isTbPre !== this.isTb || this._isPcPre !== this.isPc) {
      this._changeDetectorRef.markForCheck();
    }
  };

  init(): void {
    this.subscribeService(
      'AnabizPaymentApproverListResizeEvent',
      fromEvent(window, 'resize').pipe(throttleTime(500)),
      this._resizeEvent
    );

    apiEventAll(
      () => {
        this._getApproverStoreService.setGetApproversFromAPI();
      },
      this._getApproverStoreService.getGetApprovers$(),
      (response) => {
        if (response.data?.approvers) {
          this.approverList = response.data?.approvers;
          if (this.approverList.length > 0) {
            this.hasData = true;
          }
          this._changeDetectorRef.markForCheck();
        }
      },
      (error) => {}
    );

    const elm = document.getElementById('anabiz-payment-approver-list-body');
    if (elm) {
      this.subscribeService(
        'anabizApproverModalEventTouchMove',
        fromEvent(elm, 'touchmove').pipe(throttleTime(100)),
        (ev) => this._swipeEvent(ev as TouchEvent)
      );

      this.subscribeService('anabizApproverModalEventTouchStart', fromEvent(elm, 'touchstart'), (ev) =>
        this._setTouchY(ev as TouchEvent)
      );
    }
  }

  destroy(): void {}

  public searchApprover!: FormGroup;
  /** 座標記録用 */
  private _prevY: number = 0;
  public swipeDirection: 'up' | 'down' = 'up';

  constructor(
    private _common: CommonLibService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _getApproverStoreService: GetApproversStoreService
  ) {
    super(_common);
  }

  /**
   * swipe開始位置の座標を記録する関数
   * @param event TouchEvent
   */
  private _setTouchY(event: TouchEvent) {
    this._prevY = event.changedTouches[0].clientY;
  }

  /**
   * swipe中にswipe方向を記録する関数
   * @param event TouchEvent
   */
  private _swipeEvent(event: TouchEvent) {
    const dist = event.changedTouches[0].clientY - this._prevY;
    if (dist > 0) {
      this.swipeDirection = 'up';
    }
    if (dist < 0) {
      this.swipeDirection = 'down';
    }
    this._prevY = event.changedTouches[0].clientY;
    this._changeDetectorRef.markForCheck();
  }

  /**
   * 購入時運賃再計算API実行
   * @param val 前画面引継ぎ情報
   */
  selectApprover(val: OrdersAnaBizGetApproversResponseDataApproversInner) {
    if (val) {
      this.close(val);
    }
  }
}
